import { PERFORMANCE_STATUS_TO_CREATIVE_TYPE_MAP } from '../../../config';
import { isEditCreativeAllowed } from '../config/predicates';
import baseEditCreative from './baseEditCreative';

const editCreative = ({ data, context }) => {
    if (!isEditCreativeAllowed(data)) {
        return;
    }

    const { accountName: accountId, campaignId, id: creativeId, dimension } = data;
    const { navigate, dispatch } = context;
    const creativeType = PERFORMANCE_STATUS_TO_CREATIVE_TYPE_MAP[data.performanceStatus];

    dispatch(
        baseEditCreative({
            accountId,
            campaignId,
            creativeId,
            navigate,
            creativeType,
            dimension,
        })
    );
};

export default editCreative;
